// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ZDGb","itemTitle":"ClientEmergencyInfo_itemTitle__3eC6B","itemText":"ClientEmergencyInfo_itemText__1Bcw3"};